import { useEffect, useState } from 'react';
import { api } from './api';
import type { BootstrapData } from './types';
import PublicStore from './components/PublicStore';
import AdminPanel from './components/AdminPanel';

type ThemeMode = 'auto' | 'light' | 'dark';

function currentRoute() {
  return window.location.hash.startsWith('#/admin') ? 'admin' : 'store';
}

export default function App() {
  const [route, setRoute] = useState(currentRoute());
  const [data, setData] = useState<BootstrapData | null>(null);
  const [error, setError] = useState('');
  const [theme, setTheme] = useState<ThemeMode>(() => (localStorage.getItem('natalie-theme') as ThemeMode) || 'auto');

  const load = async () => {
    try { setData(await api.bootstrap()); setError(''); }
    catch (cause) { setError(cause instanceof Error ? cause.message : 'לא ניתן לטעון את החנות'); }
  };

  useEffect(() => {
    load();
    const onHash = () => {
      const nextRoute = currentRoute();
      setRoute(nextRoute);
      if (nextRoute === 'store') load();
    };
    const refreshStore = () => {
      if (document.visibilityState === 'visible' && currentRoute() === 'store') load();
    };
    window.addEventListener('hashchange', onHash);
    window.addEventListener('focus', refreshStore);
    document.addEventListener('visibilitychange', refreshStore);
    return () => {
      window.removeEventListener('hashchange', onHash);
      window.removeEventListener('focus', refreshStore);
      document.removeEventListener('visibilitychange', refreshStore);
    };
  }, []);

  useEffect(() => {
    localStorage.setItem('natalie-theme', theme);
    document.documentElement.dataset.theme = theme;
  }, [theme]);

  const cycleTheme = () => setTheme((value) => value === 'auto' ? 'light' : value === 'light' ? 'dark' : 'auto');

  if (route === 'admin') return <AdminPanel onChanged={load} onExit={() => { window.location.hash = ''; }} theme={theme} onTheme={cycleTheme} />;
  if (error) return <main className="center-page"><div className="error-card"><h1>לא הצלחנו לפתוח את החנות</h1><p>{error}</p><button onClick={load}>ניסיון נוסף</button></div></main>;
  if (!data) return <main className="center-page"><div className="loader" /><p>טוען את החנות...</p></main>;
  return <PublicStore data={data} onAdmin={() => { window.location.hash = '#/admin'; }} theme={theme} onTheme={cycleTheme} />;
}
